const map = {
	"./board/corner-bottom-left.png": 9928,
	"./board/corner-bottom-right.png": 6163,
	"./board/corner-top-left.png": 7056,
	"./board/corner-top-right.png": 3163,
	"./board/hole.png": 5677,
	"./board/plank-bottom.png": 1987,
	"./board/plank-left.png": 2857,
	"./board/plank-right.png": 5388,
	"./board/plank-top.png": 7065,
	"./buttons/button-large-border.png": 4085,
	"./buttons/button-medium-border.png": 3617,
	"./buttons/button-nav-border.png": 9975,
	"./flag/flag-normal.png": 7473,
	"./flag/flag-ripped.png": 9322,
	"./gems/border-default.png": 7987,
	"./gems/broken-shadow.png": 9285,
	"./gems/gem-apple.png": 1767,
	"./gems/gem-blue.png": 5187,
	"./gems/gem-bone.png": 3357,
	"./gems/gem-brick.png": 7890,
	"./gems/gem-bronze.png": 3151,
	"./gems/gem-caviar.png": 941,
	"./gems/gem-cheese.png": 4234,
	"./gems/gem-coral.png": 3906,
	"./gems/gem-foam.png": 4706,
	"./gems/gem-football.png": 3070,
	"./gems/gem-geode.png": 697,
	"./gems/gem-gold-stone.png": 1693,
	"./gems/gem-gold.png": 5637,
	"./gems/gem-golf.png": 2519,
	"./gems/gem-grass.png": 8585,
	"./gems/gem-green.png": 5032,
	"./gems/gem-honey.png": 212,
	"./gems/gem-ice.png": 3548,
	"./gems/gem-lava.png": 1229,
	"./gems/gem-marble.png": 7926,
	"./gems/gem-neutral.png": 9588,
	"./gems/gem-onion.png": 2766,
	"./gems/gem-orange.png": 8937,
	"./gems/gem-paua.png": 5998,
	"./gems/gem-pearl.png": 2531,
	"./gems/gem-pinecone.png": 2106,
	"./gems/gem-pumpkin.png": 191,
	"./gems/gem-purple.png": 1497,
	"./gems/gem-red.png": 6988,
	"./gems/gem-scarab.png": 4721,
	"./gems/gem-silver-stone.png": 9350,
	"./gems/gem-silver.png": 5078,
	"./gems/gem-slime.png": 2079,
	"./gems/gem-star.png": 1719,
	"./gems/gem-sushi.png": 5737,
	"./gems/gem-tennis.png": 8908,
	"./gems/gem-void.png": 2297,
	"./gems/gem-vortex.png": 787,
	"./gems/gem-wood.png": 1898,
	"./gems/gem-yarn.png": 637,
	"./gems/gem-yellow.png": 9071,
	"./logo.png": 9337,
	"./logo/logo-full.png": 5857,
	"./panel/panel-border-bottom.png": 288,
	"./panel/panel-border-left.png": 9198,
	"./panel/panel-border-right.png": 7401,
	"./panel/panel-border-top.png": 5496,
	"./panel/store-tablet-landscape.png": 2001,
	"./round-button/round-button-bg-pressed.png": 728,
	"./round-button/round-button-bg.png": 587
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6091;